import React from 'react'
import Title from '../../../../../components/typography/title.component'
import moment from 'moment'
import Button from '../../../../../components/buttons/buttons.component'
import PeriodInputs from '../../../../../components/form-components/period-inputs.component'
import InnerPageContainer from '../../../../../components/layout/private/inner-page-container.component'
import PaginationComponent from '../../../../../components/pagination/pagination.component'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { StyledFields } from '../../../client/pay-history/styles/fields.style'
import { AsyncSelectInput } from '../../../../../components/form-components/inputs.component'
import { BlockchainService } from '../../../../../services/blockchain.service'
import { bindActionCreators } from 'redux'
import { AdminReportsService } from '../../../../../services'
import { periodInitialValues } from '../../../../../components/form-components/period-inputs.component'
import { pointsBreakageActions } from './points-breakage.actions'

const finalDateIsOutSideRange = (value, initialDate) => {
	return (
		value.isBefore(moment().add(-24, 'months')) ||
		value.isAfter(moment().add(24, 'months')) ||
		value.isAfter(moment(initialDate, 'DD/MM/YYYY').add(24, 'months'))
	)
}

const initialDateIsOutSideRange = (value, finalDate) => {
	return (
		value.isBefore(moment().add(-24, 'months')) ||
		value.isAfter(moment().add(24, 'months')) ||
		value.isBefore(moment(finalDate, 'DD/MM/YYYY').add(-24, 'months'))
	)
}

class PointsBreakage extends React.Component {
	state = {
		isExporting: false,
		points: 0,
		values: {
			account: '',
			...periodInitialValues
		}
	}

	componentDidMount() {
		this.refs.pagination.reload()
	}

	handleExport = () => {
		this.setState({ isExporting: true }, () => {
			this.refs.form.submitForm()
		})
	}

	onSubmit = async values => {
		const { isExporting } = this.state

		this.setState({ values })

		isExporting ? this.exportData(values) : this.refs.pagination.reload()

		values.account &&
			BlockchainService.getPoints(values.account).then(({ data: points }) =>
				this.setState({ points })
			)
	}

	exportData = values => {
		const { exportData } = this.props

		exportData(values)
		this.setState({ isExporting: false })
	}

	render() {
		const { points, values } = this.state

		return (
			<InnerPageContainer>
				<Title>Breakage de pontos</Title>
				<h3 className="orange semi-bold">Filtros</h3>
				<Formik
					ref="form"
					onSubmit={this.onSubmit}
					initialValues={values}
					render={props => (
						<form noValidate onSubmit={props.handleSubmit}>
							<StyledFields>
								<AsyncSelectInput
									id="account"
									className="async-select-field"
									label="Conta"
									loadOptions={async (inputValue, callback) => {
										inputValue
											? AdminReportsService.searchClients({
													Name: inputValue,
													Sidx: 'NAME',
													Sord: 'ASC',
													Page: 1,
													RowsPerPage: 100
											  }).then(({ rows }) => {
													callback(
														rows.length
															? rows.map(
																	({
																		moveflexNumber,
																		name
																	}) => ({
																		value: moveflexNumber,
																		label: name
																	})
															  )
															: null
													)
											  })
											: null
									}}
									style={{ width: '100%' }}
									{...props}
								/>
								<PeriodInputs
									finalDateIsOutSideRange={finalDateIsOutSideRange}
									initialDateIsOutSideRange={initialDateIsOutSideRange}
									{...props}
								/>
							</StyledFields>
							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
									marginBottom: '4rem'
								}}>
								<Button
									secondary
									type="button"
									onClick={this.handleExport}
									style={{ marginRight: '15px' }}
									data-permission="AB1A4FA0ECE7308F217DBE7B3E5975B49E06BF53">
									Exportar
								</Button>
								<Button
									data-permission="13FA7DCF7F41FA664DAA3197BF7515293EF2D030"
									primary
									type="submit">
									Consultar
								</Button>
							</div>
						</form>
					)}
				/>
				<h3 className="semi-bold">
					Saldo atual:{' '}
					<span className="blue">
						{Number(points).toLocaleString('pt-BR')}
					</span>
				</h3>
				<div data-permission="13FA7DCF7F41FA664DAA3197BF7515293EF2D030">
					<PaginationComponent
						ref={'pagination'}
						getData={AdminReportsService.getPointsBreakage}
						headers={[
							{ header: 'Data da Transação', key: 'date' },
							{ header: 'Origem', key: 'source' },
							{ header: 'Destino', key: 'destination' },
							{ header: 'Produto', key: 'product' },
							{ header: 'Pontos', key: 'value' },
							{ header: 'Data de Vencimento', key: 'expirationDate' }
						]}
						params={{
							initialDate: values.initialDate,
							finalDate: values.finalDate,
							moveflexNumber: values.account
						}}
						rowsPerPage={100}
					/>
				</div>
			</InnerPageContainer>
		)
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators({ ...pointsBreakageActions }, dispatch)

const connectedPointsBreakage = connect(
	null,
	mapDispatchToProps
)(PointsBreakage)

export { connectedPointsBreakage as ModuleRootComponent }
